import React from "react";
import { cn } from "@/lib/utils";

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}



const FormInput = React.forwardRef<HTMLInputElement, FormInputProps>(
  ({ className, type = "text", ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "w-full h-8 bg-white rounded-md border border-edge-input px-3 text-sm text-ink focus:outline-none focus:ring-1 focus:ring-sage focus:border-sage",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
FormInput.displayName = "FormInput";

export { FormInput };